export enum DashboardStep {
  Empty = 'empty',
  Edit = 'edit',
  View = 'view'
}
